import { Component,  OnInit, } from '@angular/core';
import {  ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Store } from '@ngrx/store';
import { AppState } from 'app/App Store/state';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss',
  "../../../../../../assets/sass/libs/datatables.scss",],
  encapsulation: ViewEncapsulation.None,
})
export class ListComponent implements OnInit {
// meander1@DC delete contact password

  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 10,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 10;
  selectedValue=''
  isFilter:boolean=false
  // column header
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Phone", prop: "phone" },
    { name: "Actions", prop: "actions" },
  ];

  // private
  private tempData = []; 
  imageUrl=environment.apiUrls.imageUrl;
  user_role:any
  @ViewChild('name') inputName;
  searchVal:any
  row_data:any

  guideline_data:any

  referral_model ={
    refrence: '',
    report_to: '',
    notes: '',
    admin_notes: '',
  }
  emp_list =[]
  row_name:any
  user_idd:any
  form_data = new FormData()
  isRefral:any= true
  pageNumberSubscription : Subscription

  constructor(public apiService:ApiService,
              public toastr: ToastrService,
              private modalService: NgbModal,
              private session:SessionStorageService,
              private route: Router,private spinner: NgxSpinnerService,
              private activatedRoute: ActivatedRoute,private store: Store<AppState>) { 

              this.user_role=JSON.parse(localStorage.getItem('user'))
              let setting_data = JSON.parse(localStorage.getItem('setting-record'))
              let key_data = setting_data.filter((item) => item.key === 'Contacts') 
              this.guideline_data = key_data[0]?._id

              this.activatedRoute.queryParamMap.subscribe((params) => {
                let page = +params.get('page');
                this.setPage(page)
              });
              this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
              .subscribe(pageNumber => {
                this.page.pageNumber = pageNumber;
                if(pageNumber !==undefined){
                  this.page.pageNumber = pageNumber ?  pageNumber-1 :0
                }
              });

            }

  ngOnInit(): void {
    this.getContactList()
    this.getFullAndPartTimeEmp()
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  editContact(row){
    this.route.navigate(['/contact/edit',row?._id])
  }
  getContactList(){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getContactList(this.page.pageNumber +1,this.limitRef).subscribe((res:any)=>{
      this.spinner.hide()
      this.rows =res.data.items
      this.page.totalPages=res.data.totalCount
    })
  }
  pageChangeData(page:any) {
    this.route.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { page: page.offset +1 },
      queryParamsHandling: 'merge' // keep existing query params
    });
    this.apiService.getContactList(page.offset +1,page.pageSize).subscribe((res:any)=>{
      this.setPage(page.offset +1)
      this.rows =res.data.items
      this.page.totalPages=res.data.totalCount
    }) 
  }
  filter(val){
    
    if(val){
      this.apiService.contactSearch(val).subscribe((res:any)=>{
        this.rows = res?.data
        this.page.totalPages = res?.data?.length
      })
    }
   
  }
  resetFilter(){
    this.inputName.nativeElement.value=null
    this.getContactList()
  }
 
  deleteContact(id,password){
      this.apiService.deleteContact(id,password).subscribe((res:any)=>{
        if(res?.statusCode === 200){
          swal.fire({
            icon: "success",
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
          this.getContactList()
        }
        })
  }

     // ================== Delete Alert ========================
     Delete(id: any) {
      swal.fire({
        text: "Please Enter Password",
        input: 'password',
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.deleteContact(id,result.value)
  
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: 'Cancelled',
            text: 'Your file is safe :)',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
      });
    }

  openModal(content,data){
    this.row_data = data
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  getFullAndPartTimeEmp(){
    this.apiService.getFullPartEmployeeList(1,100).subscribe((res:any)=>{
      this.emp_list = res?.items
    })
  }
  getEmpId(event){
    this.referral_model.report_to 
  }
  openModalForReferral(content,userId,name) {
    this.row_name = name
    this.referral_model.refrence = `${this.user_role.id}`
    this.user_idd = userId
    this.form_data.append('refrence',this.referral_model?.refrence)
    this.form_data.append('report_to',this.referral_model?.report_to )
    this.form_data.append('notes',this.referral_model?.notes)
    this.form_data.append('admin_notes',this.referral_model?.admin_notes)
    this.form_data.append('is_refral',this.isRefral)
 

    const options: NgbModalOptions = {
      size: 'md', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    
    const modalRef = this.modalService.open(content,options);

    modalRef.result.then((result) => {
    });
   
  }
  addReferral(){
   
    this.apiService.updateUser(this.user_idd ,this.form_data).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success(res?.message)
        this.modalService.dismissAll()
        this.getContactList()      }
      else this.toastr.error(res?.error)
    })
  }
  updateContactRole(id){
    let body={
      role:'guest'
    }
    this.apiService.updateContact(id,body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('role updated successfull!')
        this.getContactList()     
      }
      else this.toastr.error(res.error)
    })
  }
}


// meander1@DC delete contact password




